module.exports = __webpack_public_path__ + "img/home-praise-avator-03.2a8a2684.png";